module.exports = __webpack_public_path__ + "assets/img/mecha-btn-15eba169.png";